import { captureError } from "@internal/error-handling";
import { type SyncState, startReplication } from "@internal/replication";
import { BehaviorSubject } from "rxjs";
import { getDbForUser } from "./db";

const state$ = new BehaviorSubject<SyncState>({
  connection: "connected",
  pending: false,
  lastInSyncAt: null,
});

/** Drives the sync indicator. See @internal/replication's SyncState. */
export const syncState$ = state$.asObservable();

let started = false;

export function startReplicationOnAuth(): void {
  if (started) return;
  started = true;

  const disabled =
    typeof window !== "undefined" &&
    (window as { __E2E_NO_REPLICATION__?: boolean }).__E2E_NO_REPLICATION__ ===
      true;
  if (disabled) {
    console.log("[rxdb] replication disabled (__E2E_NO_REPLICATION__)");
  }

  const handle = startReplication({
    table: "daily_planner",
    getCollection: async (userId) => (await getDbForUser(userId)).daily_planner,
    // Sentry, not the global error screen: a sync failure is what the
    // indicator is for, and blanking the app over one would lose the work the
    // user can still do offline.
    onError: captureError,
    disabled,
  });

  handle.syncState$.subscribe((s) => state$.next(s));
}
